import { useContext as E, useCallback as P, useState as v, useRef as F, useEffect as S } from "react";
import { I18nContext as A, ReportNamespaces as L } from "./index88.mjs";
import { warnOnce as I, hasLoadedNamespace as U, loadLanguages as R, loadNamespaces as C, isString as w, isObject as $ } from "./index89.mjs";
import { getI18n as G } from "./index90.mjs";
import { getDefaults as J } from "./index91.mjs";
const Y = (o, t) => {
  const r = F();
  return S(() => {
    r.current = o;
  }, [o, t]), r.current;
}, M = (o, t, r, l) => o.getFixedT(t, r, l), k = (o, t, r, l) => P(M(o, t, r, l), [o, t, r, l]), Q = function(o) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    i18n: r
  } = t, {
    i18n: l,
    defaultNS: j
  } = E(A) || {}, e = r || l || G();
  if (e && !e.reportNamespaces && (e.reportNamespaces = new L()), !e) {
    I("You will need to pass in an i18next instance by using initReactI18next");
    const s = (a, c) => w(c) ? c : $(c) && w(c.defaultValue) ? c.defaultValue : Array.isArray(a) ? a[a.length - 1] : a, i = [s, {}, !1];
    return i.t = s, i.i18n = {}, i.ready = !1, i;
  }
  e.options.react && e.options.react.wait !== void 0 && I("It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
  const d = {
    ...J(),
    ...e.options.react,
    ...t
  }, {
    useSuspense: b,
    keyPrefix: y
  } = d;
  let n = o || j || e.options && e.options.defaultNS;
  n = w(n) ? [n] : n || ["translation"], e.reportNamespaces.addUsedNamespaces && e.reportNamespaces.addUsedNamespaces(n);
  const u = (e.isInitialized || e.initializedStoreOnce) && n.every((s) => U(s, e, d)), z = k(e, t.lng || null, d.nsMode === "fallback" ? n : n[0], y), h = () => z, N = () => M(e, t.lng || null, d.nsMode === "fallback" ? n : n[0], y), [T, m] = v(h);
  let p = n.join();
  t.lng && (p = `${t.lng}${p}`);
  const x = Y(p), f = F(!0);
  S(() => {
    const {
      bindI18n: s,
      bindI18nStore: i
    } = d;
    f.current = !0, !u && !b && (t.lng ? R(e, t.lng, n, () => {
      f.current && m(N);
    }) : C(e, n, () => {
      f.current && m(N);
    })), u && x && x !== p && f.current && m(N);
    const a = () => {
      f.current && m(N);
    };
    return s && e && e.on(s, a), i && e && e.store.on(i, a), () => {
      f.current = !1, s && e && s.split(" ").forEach((c) => e.off(c, a)), i && e && i.split(" ").forEach((c) => e.store.off(c, a));
    };
  }, [e, p]), S(() => {
    f.current && u && m(h);
  }, [e, y, u]);
  const g = [T, e, u];
  if (g.t = T, g.i18n = e, g.ready = u, u || !u && !b) return g;
  throw new Promise((s) => {
    t.lng ? R(e, t.lng, n, () => s()) : C(e, n, () => s());
  });
};
export {
  Q as useTranslation
};
